// Generated by scripts/build-ui-icons.mjs.
export { Heart as default } from "../ui/glyphs-4";
